<template>
  <el-table-column
    prop="creator_user_name"
    sortable="custom"
    label="Létrehozta"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.creator_user_name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'creator_user_name',
  };
</script>
